import React, { Component } from 'react';
import "./tabcontrol.css"
import Tooltip from '../tooltips/tooltip';
import Button from '../button/button';

// Composant Onglets
export class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0, // Par défaut, l'onglet actif est le premier (index 0)
    };
  }

  // Méthode pour changer d'onglet
  setActiveTab = (index) => {
    this.setState({ activeTab: index });
  };

  render() {
    const { children } = this.props;
    const { activeTab } = this.state;
    /*
    <button
    key={index}
    className={index === activeTab ? 'active' : ''}
    onClick={() => this.setActiveTab(index)}
  >
    {tab.props.title}
  </button>
    */

    return (
      <>
        {/* En-tête des onglets */}

        <div className="tabs-header">
          {children.map((tab, index) => (
            <div className={index === activeTab ? 'tab-active' : 'tab-inactive'}>
            <Tooltip text={tab.props.tooltip}>
                <Button image={tab.props.image} width={28} height={28}
                key={index}
                onClick={() => this.setActiveTab(index)}
                />
            </Tooltip>
            </div>
          ))}
        </div>

        {/* Contenu de l'onglet actif */}
        <div className="tab-content">
          {children[activeTab]}
        </div>
      </>
    );
  }
}

// Composant d'un onglet individuel
export class Tab extends Component {
  render() {
    const { children } = this.props;
    return <>{children}</>;
  }
}



